<template>
    <ul class="study__list">
        <template v-for="(e, i) in props.totalData" :key="i">
            <li class="flex">
                <!-- 학습 -->
                <div v-if="e.type === 'NORMAL'" class="item__content">
                    <h4 v-if="i === 0" class="subtitle">{{ e.date }}</h4>
                    <h4 v-if="i !== 0 && e.date !== props.totalData[i - 1].date" class="subtitle">{{ e.date }}</h4>
                    <div class="panel__box">
                        <div class="full-width flex align-center justify-between">
                            <template v-for="(f, i) in e.list" :key="i">
                                <StNormal :is-top="false" :one="f" />
                            </template>
                        </div>
                    </div>
                </div>

                <!-- 진단평가_수능 -->
                <div v-if="e.type === 'DIAGNOSTIC' || e.type === 'SAT' || e.type === 'SAT_RESET'" class="item__content">
                    <h4 v-if="i === 0" class="subtitle">{{ e.date }}</h4>
                    <h4 v-if="i !== 0 && e.date !== props.totalData[i - 1].date" class="subtitle">{{ e.date }}</h4>
                    <div class="panel__box">
                        <StSAT :one="e" />
                    </div>
                </div>

                <!-- api
                    api/knowledgemap/info-all-in-normal - 수정한 지식맵 (모든 리스트 type으로 구분)
                    api/knowledgemap/info - 기존 지식맵 (현재상태) -->
                <!-- 이벤트 -->
                <template v-if="e.type === 'EVENT'" v-for="f in e.list" :key="f">
                    <div class="item__content">
                        <StEvent :date="e.date" :one="f" />
                    </div>
                </template>
            </li>
        </template>
    </ul>
</template>

<script setup>
import { onMounted, computed, ref, watch, defineProps } from 'vue';
import Comm from '@/components/common.js';

import StNormalBox from '@/views/userMapMain/components/StNormalBox.vue';
import StNormal from '@/views/userMapMain/components/StNormal.vue';
import StSAT from '@/views/userMapMain/components/StSAT.vue';
import StEvent from '@/views/userMapMain/components/StEvent.vue';

const props = defineProps({
    totalData: {
        Type: Object,
        required: true,
    },
    // one: {
    //     Type: Object,
    //     required: true,
    // },
});

const type = computed(() => {
    return props?.one?.learningType ? Comm.getNoOfStudyType(true, props.one.learningType) : '';
});
const typeName = computed(() => {
    return Comm.getTypeNameOfStudyType(type.value);
});

const classForType = computed(() => {
    return Comm.getClassOfStudyType(type.value);
});

// const kind = computed(() => props.kind);

onMounted(() => {});
</script>

<style scoped lang="scss"></style>
